var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import Icon from '@datashop/icon';
import { styledComponents } from '@datashop/theme';
var styled = styledComponents.default, withProps = styledComponents.withProps;
var Wrapper = withProps(styled.div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n  pointer-events:", "\n  opacity:", "\n"], ["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n  pointer-events:", "\n  opacity:", "\n"])), function (props) { return (props.disabled ? 'none' : 'auto'); }, function (props) { return (props.disabled ? '0.3' : '1'); });
var IconWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  height: 16px;\n  width: 13px;\n  display: inline-block;\n  border: 0;\n  border-radius: 2px;\n  cursor: default;\n  vertical-align: middle;\n  margin-right: 10px;\n"], ["\n  position: relative;\n  height: 16px;\n  width: 13px;\n  display: inline-block;\n  border: 0;\n  border-radius: 2px;\n  cursor: default;\n  vertical-align: middle;\n  margin-right: 10px;\n"])));
var Input = styled.input(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  z-index: 1; /* To render (to make it clickable) input box with 0 opacity above styled icon */\n  left: 0;\n  bottom: auto;\n  right: auto;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  padding: 0;\n  margin: 0;\n  background-color: initial;\n  cursor: pointer;\n"], ["\n  position: absolute;\n  z-index: 1; /* To render (to make it clickable) input box with 0 opacity above styled icon */\n  left: 0;\n  bottom: auto;\n  right: auto;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  padding: 0;\n  margin: 0;\n  background-color: initial;\n  cursor: pointer;\n"])));
var CheckboxIcon = withProps(styled(Icon))(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  left: -2px;\n  font-size: 17px;\n  color: ", ";\n"], ["\n  position: absolute;\n  left: -2px;\n  font-size: 17px;\n  color: ",
    ";\n"])), function (props) {
    return props.outline
        ? props.theme.datashop.palette.stone.main
        : props.theme.datashop.palette.blue.main;
});
var Label = styled.label(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  cursor: pointer;\n  font-weight: ", ";\n"], ["\n  cursor: pointer;\n  font-weight: ", ";\n"])), function (props) { return props.theme.datashop.weights.regular; });
var Checkbox = function (_a) {
    var label = _a.label, id = _a.id, disabled = _a.disabled, checked = _a.checked, indeterminate = _a.indeterminate, props = __rest(_a, ["label", "id", "disabled", "checked", "indeterminate"]);
    var checkboxIcon = indeterminate
        ? 'indeterminate_check_box'
        : checked
            ? 'check_box'
            : 'check_box_outline_blank';
    return (React.createElement(Wrapper, { disabled: disabled },
        React.createElement(IconWrapper, null,
            React.createElement(Input, __assign({ type: "checkbox", checked: checked, id: id }, props)),
            React.createElement(CheckboxIcon, { outline: !indeterminate && !checked, name: checkboxIcon })),
        React.createElement(Label, { htmlFor: id }, label)));
};
Checkbox.defaultProps = {
    checked: false,
    disabled: false,
    indeterminate: false,
};
export default Checkbox;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Checkbox.js.map